export const getBaseUrl = () => {
  const env = process.env.VUE_APP_NODE_ENV;
  const urls = {
    development: 'http://localhost:5173',
    staging: 'https://staging.sinistro.evosolucoes.com',
    qa: 'https://qa.sinistro.evosolucoes.com/',
    production: 'https://sinistro.bemprotege.com.br',
  };

  return urls[env] || urls.production;
};

export const standardMessageEvents = {
  notifyInsured: {
    header: 'Prezado Segurado,',
    processCompleted: 'O processo de análise dos arquivos foi concluído.',
    rejectedFilesTitle:
      'Segue abaixo os arquivos que foram rejeitados e o motivo da rejeição.',
    doubtsContact:
      'Caso tenha dúvidas ou precise reenviar os documentos, por favor, entre em contato conosco.',
    closing: 'Atenciosamente, Bem Protege.',
  },

  whatsapp: {
    fileRejectedList: (files) =>
      files.map(({ title, reason }) => `* ${title}: ${reason}`).join('\n'),

    generateUrl: (encryptedId, thirdPersonId) => {
      const param = thirdPersonId ? 'idTerceiro' : 'idBeneficiario';
      return `Acesse pelo link: ${getBaseUrl()}/editar-evento?${param}=${encryptedId}`;
    },
    protocolText: (protocol) => `*Protocolo:* ${protocol}`,
  },

  htmlFormatted: {
    rejectedFilesList: (files) =>
      `<ul>${files
        .map(
          ({ title, reason }) =>
            `<li><strong>${title}</strong><br /><span style="color: red;">${reason}</span></li>`,
        )
        .join('')}</ul>`,

    generateUrl: (encryptedId, thirdPersonId) => {
      const param = thirdPersonId ? 'idTerceiro' : 'idBeneficiario';
      return `Acesse pelo link: <a href="${getBaseUrl()}/editar-evento?${param}=${encryptedId}" target="_blank" style="color: blue; text-decoration: underline;">Clique aqui</a>`;
    },
    protocolText: (protocol) => `<strong>Protocolo:</strong> ${protocol}`,
  },
};
